export const CefVersion = "3.0";